import { Branch } from '../../accounting/branch';

export class Supplier {
  id: number;
  name: string;
  code: string;
  contact_person: string;
  address: string;
  city_id: string;
  phone: string;
  fax: string;
  email: string;
  notes: string;
  branches: Branch[];
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/suppliers/supplier.ts